import './LoginPage.css'

export default function LoginPage() {
  const handleSignIn = () => {
    // Get next parameter from URL if present
    const urlParams = new URLSearchParams(window.location.search)
    const next = urlParams.get('next')
    const loginUrl = next ? `/auth/login?next=${encodeURIComponent(next)}` : '/auth/login'
    window.location.href = loginUrl
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src="/pearson_new.png" alt="Pearson" style={{ width: '64px', height: '64px', marginBottom: '16px' }} />
          <h1>Pearson</h1>
          <p>Data Analyst powered by AI</p>
        </div>
        
        <button onClick={handleSignIn} className="signin-button">
          <svg className="microsoft-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23">
            <path fill="#f35325" d="M1 1h10v10H1z"/>
            <path fill="#81bc06" d="M12 1h10v10H12z"/>
            <path fill="#05a6f0" d="M1 12h10v10H1z"/>
            <path fill="#ffba08" d="M12 12h10v10H12z"/>
          </svg>
          Sign in with Microsoft
        </button>
        
        <div className="security-note">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" style={{ width: '14px', height: '14px', flexShrink: 0 }}>
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            <path d="M9 12l2 2 4-4"/>
          </svg>
          Secured with enterprise SSO
        </div>
        
        <div className="login-footer">
          Forbes Advisor Analytics Platform
        </div>
      </div>
    </div>
  )
}
